import React from 'react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';
import { createAnimation } from '../../styles/theme/util/animationUtil';

const pulse = createAnimation(
  'PulseLoader',
  '0% {transform: scale(1); opacity: 1} 45% {transform: scale(0.1); opacity: 0.7} 80% {transform: scale(1); opacity: 1}',
  'pulse'
);

const PulseLoader = ({
  loading = true,
  cssOverride = {},
  size = 8,
  margin = 2,
  ...props
}) => {
  const wrapper = {
    display: 'inherit',
    ...cssOverride
  };

  const style = idx => ({
    backgroundColor: colors.primaryScale['600'],
    width: `${size}px`,
    height: `${size}px`,
    margin,
    borderRadius: '100%',
    display: 'inline-block',
    animation: `${pulse} ${0.75}s ${
      (idx * 0.12)
    }s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)`,
    animationFillMode: 'both'
  });

  if (!loading) return null;

  return (
    <span style={wrapper} {...props}>
      <span style={style(1)} />
      <span style={style(2)} />
      <span style={style(3)} />
    </span>
  );
};

PulseLoader.propTypes = {
  loading: PropTypes.bool,
  cssOverride: PropTypes.shape({}),
  size: PropTypes.number,
  margin: PropTypes.number
};

export default PulseLoader;
